function mapBytesToIpfsLink(bytes) {
    return bytes.match(/.{1,2}/g).reduce((acc,char)=>acc+String.fromCharCode(parseInt(char, 16)),"");
}

export default mapBytesToIpfsLink;